module.exports = __webpack_public_path__ + "static/media/header_shopf2e7b4af803222852b10437b5afd0cd5.webp";